var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('transition',{attrs:{"name":"btt-fade"}},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"btt",attrs:{"type":"button","aria-label":"Back to top","title":"Back to top"},on:{"click":_vm.toTop}},[_c('b-icon',{attrs:{"icon":"chevron-up"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }